export default __webpack_public_path__ + "static/media/020-pickup truck.c9ec166a.svg";